import Network from 'app/i18n/Network';

import {
  composeValidators,
  dateValidator,
  emailValidator,
  numberValidator,
  textMaxLengthValidator,
  textValidator,
} from '../../../components/Form/utils/validators';
export const NETWORK_ASSET_FORM_RULES = {
  userName: {
    validate: composeValidators(
      textValidator('PROCURE_12003'),
      textMaxLengthValidator('PROCURE_12004', 30),
    ),
  },
  email: {
    validate: composeValidators(
      textValidator('PROCURE_2001'),
      emailValidator('PROCURE_2002'),
    ),
  },
  location: {
    validate: textValidator('PROCURE_12003'),
  },
  department: {
    validate: textValidator('PROCURE_12007'),
  },
  startDate: {
    validate: dateValidator('PROCURE_12009'),
  },
  endDate: {
    validate: dateValidator('PROCURE_12010'),
  },
  numberValidation: {
    validate: numberValidator('PROCURE_12011')
  } 
};
